<template>
  <div class="c-controls">
		<div class="c-videocontrols">
      <button @click="play">
        <svg class="icon icon_play"><use xlink:href="#icon_play"></use></svg>
      </button>
			<button @click="pause">
				<svg class="icon icon_pause"><use xlink:href="#icon_pause"></use></svg>
			</button>
			<button @click="stop">
				<svg class="icon icon_stop"><use xlink:href="#icon_stop"></use></svg>
			</button>
		</div>
  </div>
</template>

<script>
import BaseControl from './BaseControl';

export default {
	name: 'VideoControl',
	mixins: [BaseControl],
	methods: {
		pause() {
			this.subcommand('video.pause');
		},
		play() {
			this.subcommand('video.play');
		},
		stop() {
			this.subcommand('video.stop');
		},
	},
};
</script>

<style scoped></style>
